<script>
    export default {
        name: "PromocodeColors",
        props: {
            colors: Array,
            text: String,
        },
        computed: {
            colorText() {
                return this.text ? this.text : "на все цвета";
            },
        },
    };
</script>

<template>
    <div class="promocode-colors">
        <div class="promocode-colors__text">{{ colorText }}</div>
        <div class="promocode-colors__list">
            <div
                v-for="color in colors"
                :key="color"
                class="promocode-colors__item"
                :style="{ 'background-color': color }"
            ></div>
        </div>
    </div>
</template>

<style lang="scss">
    .promocode-colors__text {
        margin-top: 12px;
        margin-bottom: 8px;
        color: var(--primary);
        font-size: 14px;
        font-weight: 300;
        line-height: 20px;
    }

    .promocode-colors__list {
        display: flex;
    }

    .promocode-colors__item {
        @include box(20px);
        margin-right: 6px;
        border-radius: 50%;
    }
</style>
